import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Label, Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: "",
            obligatorio: false
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    getData() {
        const { nombre, obligatorio } = this.state;
        return {
            nombre: nombre,
            obligatorio: obligatorio
        }
    }

    setData(data) {
        this.setState({
            nombre: data.nombre,
            obligatorio: data.obligatorio
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plan.campos.edit}
                postUrl={api.proyectos.config.plan.campos.edit}
                onSubmit={() => this.props.onSubmit()}
                onPreSubmit={() => this.getData()}
                onGotData={(data) => this.setData(data)}
                id={this.props.id}
                successMessage={"El Campo del Plan de Trabajo ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Campo del Plan de Trabajo"}
                buttonTitle={"Editar Campo del Plan de Trabajo"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del campo</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input value={this.state.nombre} onChange={(e) => this.setState({ nombre: e.target.value })} type="text" name="nombre"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                        <div className="ui-row-1">
                            <label className="ui-checkbox-opt">
                                <input checked={this.state.obligatorio} onChange={(e) => this.setState({ obligatorio: e.target.checked })} type="checkbox" name="obligatorio"></input>
                                <span>Obligatorio</span>
                            </label>
                            <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_Campos/Edit.js